import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { OptionData } from './type';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-6',
  props: {
    optionData: {}
  },
  setup(__props: any) {

const props = __props;

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024 192">
  <g id="xiangguandiaoyan6" transform="translate(0 -147)">
    <rect id="矩形_3074" data-name="矩形 3074" width="337" height="96" transform="translate(0 243)" fill="#e5e5e5"/>
    <rect id="矩形_3075" data-name="矩形 3075" width="340" height="96" transform="translate(342 243)" fill="#e5e5e5"/>
    <text id="_10题" data-name="10题" transform="translate(151 297)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.topicSum
    }题</tspan></text>
    <text id="_10个" data-name="10个" transform="translate(495 297)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.userSum
    }个</tspan></text>
    <rect id="矩形_3076" data-name="矩形 3076" width="337" height="96" transform="translate(687 243)" fill="#e5e5e5"/>
    <text id="主体分析" transform="translate(822 297)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.analysisDimen
    }</tspan></text>
    <path id="矩形_1888" data-name="矩形 1888" d="M20,0H317a20,20,0,0,1,20,20V96a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" transform="translate(0 147)" fill="var(--theme-color-1)"/>
    <path id="矩形_3072" data-name="矩形 3072" d="M20,0H320a20,20,0,0,1,20,20V96a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" transform="translate(342 147)" fill="var(--theme-color-1)"/>
    <path id="矩形_3073" data-name="矩形 3073" d="M20,0H317a20,20,0,0,1,20,20V96a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" transform="translate(687 147)" fill="var(--theme-color-1)"/>
    <text id="当前报告总题目" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5 + 20
        : '108'
    } 201)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[0] || '当前报告总题目'
}</tspan></text>
    <text id="总参与人数_人或者机构_" data-name="总参与人数（人或者机构）" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5 + 310
        : '408'
    } 201)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[1] || '总参与人数（人或者机构）'
}</tspan></text>
    <text id="分析维度" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5 + 680
        : '822'
    } 201)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[2] || '分析维度'
}</tspan></text>
  </g>
</svg>
`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-block",
    innerHTML: svg
  }))
}
}

})